import { useQueryClient } from "react-query"

import { useQuery } from "react-query"
import { useMutation } from "react-query"
import { notification } from "antd"
import { getTenantWorkDaySettingsData, updateTenantWorkDaySetting } from "./tenantWorkDaySettingsApi"
import { TenantWorkDaySetting } from "./tenantWorkDaySetting"

export const useTenantWorkDaySettingsDataQuery = () => {
  return useQuery(['tenantWorkDaySetting'], () => getTenantWorkDaySettingsData())
}

export const useUpdateTenantWorkDaySettingsMutation = () => {
  const queryClient = useQueryClient()
  return useMutation((request :  TenantWorkDaySetting ) => updateTenantWorkDaySetting(request), {
    onSuccess: () => {
      queryClient.invalidateQueries(['tenantWorkDaySetting'])
    },
    onError: () => {
      notification.error({
        message: 'There was a problem creating the tenant work day settings.'
      })
    }
  })
}